import { useCallback, useEffect, useState } from 'react'

import { useAppDispatch } from '@/hooks/redux'
import { useAppSelector } from '@/store'
import { removeDentinRecipeIndex } from '@/store/appSlice'
import { removeDentinTarget, setdentinRecipeOutput } from '@/store/fullLayering'

import DentinTooltip from './components/DentinTooltip'

const KonvaDentin = () => {
  const dispatch = useAppDispatch()
  const dentinColor = useAppSelector((state) => state.fullLayering.dentinColor)
  const dentinoutput = useAppSelector(
    (state) => state.fullLayering.dentinRecipeOutput,
  )

  const canvasImage = useAppSelector((state) => state.app.canvasImage)

  const [tooltipOpenMap, setTooltipOpenMap] = useState<Record<string, boolean>>(
    {},
  )

  useEffect(() => {
    const initialTooltipState: Record<string, boolean> = {}
    Object.keys(dentinColor?.[canvasImage?.id] || {}).forEach((key) => {
      initialTooltipState[key] = true
    })
    setTooltipOpenMap(initialTooltipState)
  }, [dentinColor, dentinoutput, canvasImage?.id])

  const handleToggleTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: !prev[key] }))
  }, [])

  const handleCloseTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: false }))
  }, [])

  const handleDeleteDentinKey = useCallback(
    (key: string) => {
      if (!canvasImage?.id) return

      dispatch(
        setdentinRecipeOutput({
          imageId: canvasImage.id,
          key,
          result: undefined,
        }),
      )
      dispatch(
        removeDentinTarget({
          imageId: canvasImage.id,
          key,
        }),
      )
      dispatch(
        removeDentinRecipeIndex({
          workflow: 'fullLayering',
          imageId: canvasImage.id,
          key,
        }),
      )
    },
    [dispatch, canvasImage?.id],
  )

  return (
    <>
      {Object.keys(dentinColor?.[canvasImage?.id] || {}).map((key) => {
        const data = dentinColor?.[canvasImage?.id]?.[key]
        const output = dentinoutput?.[canvasImage?.id]?.[key]
        if (!data.output || !output) return null

        return (
          <DentinTooltip
            key={key}
            keyName={key}
            data={data}
            output={output}
            open={!!tooltipOpenMap[key]}
            toggle={handleToggleTooltip}
            close={handleCloseTooltip}
            onDelete={handleDeleteDentinKey}
            workflow="fullLayering"
          />
        )
      })}
    </>
  )
}

export default KonvaDentin
